import { InMemoryCache } from '@apollo/client'

const takeIncoming = (existing, incoming) => {
  return incoming
}

const mergeActivityLogs = (existing, incoming, { args, readField }) => {
  if (!existing) return incoming

  const existingEdges = existing.edges ?? []
  const incomingEdges = incoming.edges ?? []
  const edges = args?.after
    ? [...existingEdges, ...incomingEdges]
    : [...incomingEdges, ...existingEdges]
  const seenIds = new Set()
  const uniqueEdges = edges.filter((edge) => {
    if (!edge) return false

    const node = readField('node', edge)
    const id = readField('id', node)
    if (!id || seenIds.has(id)) return false

    seenIds.add(id)
    return true
  })
  const keepExistingPageInfo =
    !args?.after && existingEdges.length > incomingEdges.length

  return {
    ...incoming,
    edges: uniqueEdges,
    pageInfo: keepExistingPageInfo ? existing.pageInfo : incoming.pageInfo
  }
}

export const cache: InMemoryCache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        getCurrentUserAccount: {
          merge(existing, incoming, { mergeObjects }) {
            return mergeObjects(existing, incoming)
          }
        },
        getOrderProcessDependencies: {
          merge: takeIncoming
        },
        searchActivityLogs: {
          keyArgs: ['input'],
          merge: mergeActivityLogs
        }
      }
    },
    Account: {
      merge: true,
      fields: {
        organization: {
          merge(existing, incoming) {
            return {
              ...existing,
              ...incoming
            }
          }
        }
      }
    },
    Operator: {
      merge: true
    },
    ProductionUnit: {
      merge: true
    },
    SizeStandard: {
      fields: {
        sizes: {
          merge: takeIncoming
        }
      }
    },
    Order: {
      fields: {
        orderVariants: {
          merge: takeIncoming
        },
        attachments: {
          merge: takeIncoming
        }
      }
    },
    OrderVariant: {
      fields: {
        sizeMatrices: {
          merge: takeIncoming
        },
        productionSizeMatrices: {
          merge: takeIncoming
        },
        customFieldValues: {
          merge: takeIncoming
        }
      }
    },
    OrderProcess: {
      fields: {
        attachments: {
          merge: takeIncoming
        }
      }
    },
    ProductionOrder: {
      fields: {
        attachments: {
          merge: takeIncoming
        }
      }
    },
    ProductionOrderQuantity: {
      merge: true
    },
    ProductionOrderProcess: {
      fields: {
        attachments: {
          merge: takeIncoming
        }
      }
    },
    ShopFloorPlan: {
      fields: {
        machines: {
          merge: takeIncoming
        },
        operators: {
          merge: takeIncoming
        }
      }
    },
    CuttingPlanMaterial: {
      fields: {
        cuttingActions: {
          merge: takeIncoming
        }
      }
    },
    ShopFloorMachine: {
      fields: {
        assignments: {
          merge: takeIncoming
        },
        position: {
          merge: takeIncoming
        }
      }
    }
  }
})
